/* NoSuggestionsBody.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _15 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _14 = "._1e0c1ule{display:block}";
const _13 = "@media (min-width:64rem){._dm251ule{display:block}}";
const _12 = "._1e0cglyw{display:none}";
const _11 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _10 = "._18m915vq{overflow-y:hidden}";
const _9 = "._1reo15vq{overflow-x:hidden}";
const _8 = "._o5721q9c{white-space:nowrap}";
const _7 = "._1bto1l2s{text-overflow:ellipsis}";
import { BodySmall } from '@atlassian/mpac-primitives';
import { ellipsisCompiled } from '@atlassian/mpac-ui/theme';
import React from 'react';
import { desktopOnly, mobileOnly } from '../../SearchUtils/ResponsiveUtils';
const _6 = "._zulp1eps{gap:var(--ds-space-100)}";
const _5 = "._1wpz1fhb{align-self:stretch}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._1bah1yb4{justify-content:space-between}";
const _2 = "._1yt41j4z{padding:var(--ds-space-250) var(--ds-space-400) var(--ds-space-200) var(--ds-space-400)}";
const _ = "._1e0c1txw{display:flex}";
const SearchSubHeader = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _1yt41j4z _1bah1yb4 _4cvr1h6o _1wpz1fhb _zulp1eps", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SearchSubHeader.displayName = 'SearchSubHeader';
}
const baseLabel = {
  color: "var(--ds-text-subtle)"
};
const LargeLabel = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_7, _8, _9, _10, _11, _12, _13]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bto1l2s _o5721q9c _1reo15vq _18m915vq _syaz1k3w _1e0cglyw _dm251ule", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  LargeLabel.displayName = 'LargeLabel';
}
const SmallLabel = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_7, _8, _9, _10, _11, _14, _15]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bto1l2s _o5721q9c _1reo15vq _18m915vq _syaz1k3w _1e0c1ule _dm25glyw", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SmallLabel.displayName = 'SmallLabel';
}
export function NoSuggestionsBody(_ref4) {
  let {
    query
  } = _ref4;
  return /*#__PURE__*/React.createElement(SearchSubHeader, null, /*#__PURE__*/React.createElement(LargeLabel, null, "Press Enter (\u23CE) to see results for \u2018".concat(query, "\u2019")), /*#__PURE__*/React.createElement(SmallLabel, null, "Press Enter (\u23CE) to see results"));
}